import {forkJoin,  Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BuildingFlat, BuildingWallMaterials, CountRooms, ICity, IDeveloper, IFlatSalesWrapper, IObject, IRegion, ISpotWrapper, RoomType, RoomTypeItem, SpotRank, WallMaterial, WallMaterialType, FlatsInfo, BuildingOtherRooms, BuildingFloor, SetBuilding, Block, ICurator, SingleNews, FlatsFloorInfo } from "../models/models";
import { Passwords } from "../../components/change-password/change-password.component";
import { OneFlatSales, OneFlatSalesSet1 } from "../../components/flats-modal/flats-modal.component";
import { FlatFurnishTypes } from "../../components/typeofot/typeofot.component";
import { IConstructionInfo } from "../../components/object/object-construction/object-construction.component";
import { BuildProcess } from "../../components/object/object-construction/line-chart-construction/line-chart-construction.component";
import { environment } from "../../../environments/environment";
import { CommentPhoto } from "../../components/object/object-gallery/object-album/object-album.component";
// import { FloorInfoSet11, IConstructionInfo } from "../../components/object/object-construction/object-construction.component";



@Injectable()
export class ServerService extends BaseService {
  api = environment.apiUrl;
  api_widget = environment.apiWidget;
  tokenUrl = 'Token';

  private httpHeaders = new HttpHeaders({
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
  });

  constructor(http: HttpClient) {
    super(http);
  }

  getTokenWithRefreshToken(refreshToken: string): any {
    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken);

    return this.http.post(this.api + this.tokenUrl, body.toString(), {
      headers: this.httpHeaders
    }).toPromise().then(res => res);
  }

  getToken(name: string, password: string): any {
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', name)
      .set('password', password);

    return this.http.post(this.api + this.tokenUrl, body.toString(), {
      headers: this.httpHeaders
    }).toPromise().then(res => res);
  }

  ChangePassword(OldPassword: string, NewPassword: string, ConfirmPassword: string): any {
    const body = new HttpParams()
      .set("grant_type", "password")
      .set("OldPassword", OldPassword)
      .set("NewPassword", NewPassword)
      .set("ConfirmPassword", ConfirmPassword);
    let uri = "api/Account/ChangePassword";
    return this.http.post(this.api + uri, body.toString(), {
      headers: this.httpHeaders
    }).toPromise().then(res => res);
  }

  getFlatSalesSchedule(livingComplex: number) {
    let uri = "FlatSalesSchedule/Get";
    return this.get(this.api + uri, { livingComplex });
  }

  getObjects(): Promise<any> {
    let uri = "LivingComplexes/GetAll";
    let token = localStorage.getItem("token");
    return this.http.get(this.api + uri, {
      headers: new HttpHeaders({
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + token
      })
    }).toPromise().then(res => res);
  }

  getObject(id: number): Promise<any> {
    let params = new HttpParams();
    params = params.append("livingComplexID", id.toString());
    let uri = "LivingComplexes/Get";
    let token = localStorage.getItem("token");
    return this.http.get(this.api + uri, {
      headers: new HttpHeaders({
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + token
      }),
      params
    }).toPromise().then(res => res);
  }

  setObject(object: IObject) {
    let uri = "LivingComplexes/Set";
    return this.post(this.api + uri, object);
  }

  changePassword(object: Passwords) {
    let uri = "api/Account/ChangePassword";
    return this.post(this.api + uri, object);
  }

  getMIOs(): Promise<IDeveloper[]> {
    let uri = "Info/GetMIOs";
    return this.get(this.api + uri, {});
  }

  getRegions(): Promise<IRegion[]> {
    let uri = "Info/GetRegions";
    return this.get(this.api + uri, {
    });
  }

  getCities(regionId: number): Promise<ICity[]> {
    let uri = "Info/GetCities";
    return this.get(this.api + uri, {
      regionId: regionId,
      // portalID: portalID
    });
  }

  getGetAuthCompanies(): Promise<IDeveloper[]> {
    let uri = "Info/GetAuthCompanies";
    return this.get(this.api + uri, {});
  }

  getGeneralContractors(): Promise<IDeveloper[]> {
    let uri = "Info/GetGeneralContractors";
    return this.get(this.api + uri, {});
  }

  getAuthorSupervisions(): Promise<IDeveloper[]> {
    let uri = "Info/GetAuthorSupervisions";
    return this.get(this.api + uri, {});
  }

  getTechnicalSupervisions(): Promise<IDeveloper[]> {
    let uri = "Info/GetTechnicalSupervisions";
    return this.get(this.api + uri, {});
  }

  getSupervisors(mioID?: number): Promise<IDeveloper[]> {
    let uri = "Info/GetSupervisors";
    return this.get(this.api + uri, { mioId: mioID });
  }

  insertLivingComplexePhoto(LivingComplexID: number, FileExtension: string, photo: File) {
    let uri = "Files/UploadLivingComplexFile";
    const formData: FormData = new FormData();
    formData.append("LivingComplexID", LivingComplexID.toString());
    formData.append("FileExtension", FileExtension);
    formData.append("photo", photo, photo.name);
    return this.post(this.api + uri, formData);
  }

  uploadObjectDocument(
    LivingComplexID: number,
    FileExtension: string,
    photo: File,
    FileTypeId: number
  ) {
    let uri = "LivingComplexes/UploadDocument";
    const formData: FormData = new FormData();

    formData.append("LivingComplexID", LivingComplexID.toString());
    formData.append("documentType", FileTypeId.toString());
    formData.append("FileExtension", FileExtension);
    formData.append("photo", photo, photo.name);
    return this.post(this.api + uri, formData);
  }

  uploadSpotActDocument(spotId: number, fileTypeId: number, file: File) {
    let uri = "BuildingFiles/UploadBuildingDocuments";
    const formData: FormData = new FormData();

    formData.append("buildingID", spotId.toString());
    formData.append("documentType", fileTypeId.toString());
    formData.append("photo", file, file.name);
    return this.post(this.api + uri, formData);
  }

  deleteObjectDocument(id: number) {
    let uri = "LivingComplexes/DeleteDocument";
    return this.get(this.api + uri, {
      fileID: id
    });
  }
  deleteObjectDocumentAct(id: number) {
    let uri = "Files/DeleteDocument";
    return this.get(this.api + uri, {
      fileID: id
    });
  }

  deleteLivingComplexePhoto(LivingComplexID: number) {
    let uri = "LivingComplexes/DeletePhoto";
    return this.get(this.api + uri, {
      LivingComplexID: LivingComplexID
    });
  }

  getAllBuildingsPhotoById(buildingId: number, livingComplexID: number) {
    let uri = "BuildingFiles/Get";
    return this.get(this.api + uri, {
      buildingId: buildingId,
      livingComplexID: livingComplexID
    });
  }

  deleteBuildingPhotoById(fileID: number) {
    let uri = "BuildingFiles/DeleteById";
    return this.get(this.api + uri, {
      fileID: fileID
    });
  }

  insertBuildingPhoto(buildingID: number, fileSource: File, fileThumb = null, fileTypeID, fileExtension, updatedOn = "") {
    let uri = this.api + "Files/UploadBuildingFile";
    const formData: FormData = new FormData();
    formData.append("buildingID", buildingID.toString());
    formData.append("fileSource", fileSource, fileSource.name);
    formData.append("fileThumb", fileThumb);
    formData.append("fileTypeID", fileTypeID);
    formData.append("fileExtension", fileExtension);
    formData.append("updatedOn", updatedOn);
    return this.post(uri, formData);
  }

  getBuildingsByLivingComplexId(livingComplexId: number): Promise<ISpotWrapper[]> {
    let uri = "LivingComplexes/GetBuildings";
    return this.get(this.api + uri, {
      livingComplexId: livingComplexId
    });
  }

  getSpotActDoc(buildingId: number) {
    let uri = "BuildingFiles/GetBuildingDocuments";
    return this.get(this.api + uri, {
      buildingId: buildingId
    });
  }

  getBuildingStageFactValues(buildingId: number, stageId: number) {
    let uri = "BuildingStage/GetFactValues";
    return this.get(this.api + uri, {
      buildingId: buildingId,
      stageId: stageId
    });
  }

  getBuildingAllStagesFactValues(buildingId: number) {
    let uri = "BuildingStage/GetFactValues";
    let s1 = this.get(this.api + uri, { buildingId: buildingId, stageId: 1 });
    let s2 = this.get(this.api + uri, { buildingId: buildingId, stageId: 2 });
    let s3 = this.get(this.api + uri, { buildingId: buildingId, stageId: 3 });
    let s4 = this.get(this.api + uri, { buildingId: buildingId, stageId: 4 });
    let s5 = this.get(this.api + uri, { buildingId: buildingId, stageId: 5 });
    let s6 = this.get(this.api + uri, { buildingId: buildingId, stageId: 6 });
    let s7 = this.get(this.api + uri, { buildingId: buildingId, stageId: 7 });
    let s8 = this.get(this.api + uri, { buildingId: buildingId, stageId: 8 });
    return forkJoin([s1, s2, s3, s4, s5, s6, s7, s8]);
  }

  setBuildingStageFactValues(options) {
    let uri = "BuildingStage/SetFactValues";
    return this.post(this.api + uri, options);
  }

  getInvestAmount(livingComplexId: number, isOwnAmount?: boolean) {
    let uri = 'LivingComplexes/GetInvestAmount';
    if (typeof (isOwnAmount) === 'undefined') {
      return this.get(this.api + uri, { livingComplexId: livingComplexId });
    }
    return this.get(this.api + uri, { livingComplexId: livingComplexId, isOwnAmount: isOwnAmount });
  }

  setInvestAmount(any) {
    let uri = "LivingComplexes/SetInvestAmount";
    return this.post(this.api + uri, any);
  }

  getFlatSales(livingComplexId: number): Promise<IFlatSalesWrapper> {
    let uri = "LivingComplexes/GetFlatSales";
    return this.get(this.api + uri, {
      livingComplexId: livingComplexId
    });
  }

  setFlatSales(options) {
    let uri = "LivingComplexes/SetFlatSales";
    return this.post(this.api + uri, options);
  }

  setPlanDates(object: any[] = []) {
    let uri = "BuildingStage/SetPlanDates";
    return this.post(this.api + uri, object);
  }

  getInvestStatus(livingComplexId: number, flag: boolean) {
    let uri = "LivingComplexes/GetInvestStatus";
    return this.get(this.api + uri, {
      livingComplexId: livingComplexId,
      flag: flag
    });
  }

  setInvestStatus(livingComplexId: number, flag: boolean, status: boolean) {
    let uri = "LivingComplexes/SetInvestStatus";
    return this.get(this.api + uri, {
      livingComplexId: livingComplexId,
      flag: flag,
      status: status
    });
  }

  getUserInfo(userName: string) {
    let uri = "Users/GetFIO";
    let token = localStorage.getItem("token");
    return this.http.get(this.api + uri, {
      params: {
        userName: userName
      },
      headers: new HttpHeaders({
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + token
      })
    }).toPromise().then(res => res);
  }

  getLocation(address: string) {
    let url = `http://maps.google.com/maps/api/geocode/json`;
    return this.get(url, {
      address: address
    });
  }

  createDeveloper(name: string, bin: string, typeId: number) {
    let url = `LivingComplexes/AddOrganization`;
    return this.get(this.api + url, {
      name: name,
      typeId: typeId,
      bin: bin
    });
  }

  deleteFactValue(buildingId: number, stageId: number, factDate: number) {
    let url = "BuildingStage/DeleteFactValue";
    return this.get(this.api + url, {
      buildingId: buildingId,
      stageId: stageId,
      factDate: factDate
    });
  }

  setNews(title: string, newsText: string, regionList: string, file: File) {
    let url = "News/Set";
    const formData: FormData = new FormData();
    formData.append("title", title);
    formData.append("newsText", newsText);
    formData.append("regionList", regionList);
    formData.append("file", file, file.name);
    return this.post(this.api + url, formData);
  }
  getNews(regionId): Promise<SingleNews[]> {
    let url = "News/Get";

    return this.get(this.api + url, {
      regionId: regionId
    });
  }

  setCheckNews(newsID) {
    let url = "News/UserCheckNews?newsID=" + newsID;
    return this.post(this.api + url, {});
  }

  getFlatsFloors(buildingID): Promise<FlatsFloorInfo> {
    let url = "Info/GetBuildingFlatsInfo";
    return this.get(this.api + url, {
      buildingID: buildingID
    });
  }

  getRealizationFlatSalesInfo(buildingID): Promise<FlatsInfo[]> {
    let url = "Buildings/GetBuildingFlatSalesInfo";
    return this.get(this.api + url, {
      buildingID: buildingID
    });
  }

  getRealizationOneFlatSalesInfo(flatID: number): Promise<OneFlatSales> {
    let url = "LivingComplexes/GetBuildingFlatSales";
    return this.get(this.api + url, { id: flatID });
  }

  getConstructionFullInfo(buildingID, floorID): Promise<IConstructionInfo[]> {
    let url = "BuildingStage/GetBuildingLevelStages";
    return this.get(this.api + url, {
      buildingID: buildingID,
      floorID: floorID
    });
  }

  getBuildingLevelStages(buildingID, floorID?) {
    let url = 'Widget_B_1_BuildingObjects/GetBuildingLevelStages';
    return this.get(this.api_widget + url, { buildingID: buildingID, floorID: floorID });
  }

  insertRealizationOneFlatSalesInfo(
    oneFlatSales: OneFlatSalesSet1
  ): Promise<any> {
    let url = "Buildings/SetBuildingFlatSales";
    const formData: FormData = new FormData();
    formData.append("FlatConfigurationID", oneFlatSales.flatConfigurationID.toString());
    formData.append("ColumnID", oneFlatSales.columnID.toString());
    formData.append("FlatNumber", oneFlatSales.flatNumber === null ? "" : oneFlatSales.flatNumber);
    formData.append("FlatArea", oneFlatSales.flatArea === null ? "" : oneFlatSales.flatArea.toString());
    formData.append("SaleAmount", oneFlatSales.saleAmount === null ? "" : oneFlatSales.saleAmount.toString());
    formData.append("PriceAmount", oneFlatSales.priceAmount === null ? "" : oneFlatSales.priceAmount.toString());
    formData.append("SaleDate", oneFlatSales.saleDate === null ? "" : this.formatDate2(oneFlatSales.saleDate));
    formData.append("IsCornerFlat", oneFlatSales.isCornerFlat ? "true" : "false");
    formData.append("FurnishItemsList", oneFlatSales.furnishItemsList);
    if (typeof oneFlatSales.fileTypeId !== "undefined") {
      formData.append("FileTypeId", oneFlatSales.fileTypeId.toString());
      formData.append("File", oneFlatSales.file);
    }
    return this.post(this.api + url, formData);
  }

  updateRealizationOneFlatSalesInfo(
    oneFlatSales: OneFlatSalesSet1
  ): Promise<any> {
    let url = "Buildings/UpdateBuildingFlatSales";
    const formData: FormData = new FormData();
    formData.append("ID", oneFlatSales.ID.toString());
    // formData.append('FlatConfigurationID', oneFlatSales.flatConfigurationID.toString());
    // formData.append('ColumnID', oneFlatSales.columnID.toString());
    formData.append("FlatNumber", oneFlatSales.flatNumber === null ? "" : oneFlatSales.flatNumber);
    formData.append("FlatArea", oneFlatSales.flatArea === null ? "" : oneFlatSales.flatArea.toString());
    formData.append("SaleAmount", oneFlatSales.saleAmount === null ? "" : oneFlatSales.saleAmount.toString());
    formData.append("PriceAmount", oneFlatSales.priceAmount === null ? "" : oneFlatSales.priceAmount.toString());
    formData.append("SaleDate", oneFlatSales.saleDate === null ? "" : this.formatDate2(oneFlatSales.saleDate));
    formData.append("IsCornerFlat", oneFlatSales.isCornerFlat ? "true" : "false");
    formData.append("FurnishItemsList", oneFlatSales.furnishItemsList);
    if (typeof oneFlatSales.fileTypeId !== "undefined") {
      formData.append("FileTypeId", oneFlatSales.fileTypeId.toString());
      formData.append("File", oneFlatSales.file);
    }
    return this.post(this.api + url, formData);
  }

  insertStages(spotConstInfo: IConstructionInfo): Promise<any> {
    let url = `BuildingStage/SetBuildingStagePlanValue?buildingStageID=${
      spotConstInfo.id
      }&fromDate=${this.formatDate2(
        spotConstInfo.planFromDate
      )}&toDate=${this.formatDate2(spotConstInfo.planToDate)}&planValue=${
      spotConstInfo.planValue
      }`;
    return this.post(this.api + url, {});
  }

  insertSimpleStages(buildingID, fullInfo: boolean): Promise<any> {
    let url = `BuildingStage/SetBuildingIsSimpleStagest?buildingID=${
      buildingID
      }&isSimpleStagesInput=${fullInfo}`;
    return this.post(this.api + url, {});
  }

  getFlatFurnishTypes(): Promise<FlatFurnishTypes[]> {
    let uri = "Info/FlatFurnishTypes";
    return this.get(this.api + uri, {});
  }

  getGetFlatFurnishType(): Promise<FlatFurnishTypes[]> {
    let uri = "Info/GetFlatFurnishType";
    return this.get(this.api + uri, {});
  }

  getHistory(objectId: number): Promise<IHistory[]> {
    let url = "LivingComplexes/GetHistory";
    return this.get(this.api + url, {
      livingComplexId: objectId
    });
  }

  getLivingComplexInfo_BuildProcess(buildingID: number): Promise<IBuildProcess> {
    let url = "Widget_B_1_1_1_1_LivingComplexInfo_BuildProcess/Get";
    return this.get("http://api.genro.kz/widgetapi/" + url, {
      buildingID: buildingID
    });
  }


  setBuilding(building: SetBuilding) {
    let url = "Buildings/SetBuilding";
    return this.post(this.api + url, building);
  }

  //Get method for WallMaterialTypes
  getWallMaterialTypes(): Promise<WallMaterialType[]> {
    let url = "Info/GetWallMaterialTypes";
    return this.get(this.api + url, {});
  }
  getWallMaterials(materialTypeID: number): Promise<WallMaterial[]> {
    let url = "Info/GetWallMaterials";
    return this.get(this.api + url, { materialTypeID: materialTypeID });
  }

  //Get method for RoomTypes
  getBuildingRoomTypes(): Promise<RoomType[]> {
    let url = "Info/GetBuildingOtherRoomTypes";
    return this.get(this.api + url, {});
  }
  getBuildingRooms(roomTypeID: number): Promise<RoomTypeItem[]> {
    let url = "Info/GetBuildingOtherRoomTypeItems";
    return this.get(this.api + url, { roomTypeID: roomTypeID });
  }

  //Get method for Spot Rank
  getBuildingClasses(): Promise<SpotRank[]> {
    let url = "Buildings/GetBuildingClasses";
    return this.get(this.api + url, {});
  }
  getBuildingOtherRooms(buildingID: number, roomTypeID?: number): Promise<any> {
    let url = "Buildings/GetBuildingOtherRooms";
    return this.get(this.api + url, {
      buildingID: buildingID,
      roomTypeID: roomTypeID
    });
  }
  setBuildingOtherRoomsWf(buildingOtherRooms: BuildingOtherRooms[]) {
    let url = 'Buildings/SetBuildingRooms_wf';
    return this.post(this.api + url, buildingOtherRooms);
  }
  setBuildingOtherRooms(buildingOtherRooms: OneFlatSalesSet1) {
    let url = 'Buildings/SetBuildingOtherRooms';
    const formData: FormData = new FormData();
    formData.append("BuildingID", buildingOtherRooms.buildingID.toString());
    formData.append("RoomTypeItemID", buildingOtherRooms.roomTypeItemID.toString());
    formData.append("Delete", buildingOtherRooms.delete ? "true" : "false");
    formData.append("Area", buildingOtherRooms.area === null ? "0" : buildingOtherRooms.area.toString());
    formData.append("PlaceCount", buildingOtherRooms.placeCount === null ? "0" : buildingOtherRooms.placeCount.toString());
    if (typeof buildingOtherRooms.fileTypeId !== "undefined") {
      formData.append("FileTypeId", buildingOtherRooms.fileTypeId.toString());
      formData.append("File", buildingOtherRooms.file);
    }
    return this.post(this.api + url, formData);
  }

  //Get method for Count of Rooms
  getBuildingCountOfRooms(): Promise<CountRooms[]> {
    let url = "Info/GetBuildingCountOfRooms";
    return this.get(this.api + url, {});
  }

  //Get method for Building Flats Info
  getBuildingFlatsInfo(buildingID: number): Promise<BuildingFlat> {
    let url = "Info/GetBuildingFlatsInfo";
    return this.get(this.api + url, { buildingID: buildingID });
  }
  //Buildings/SetBuildingFloor?buildingID={buildingID}&floorID={floorID}&roomCountID={roomCountID}&flatCount={flatCount}
  setBuildingFloor(buildingFloor: BuildingFloor[]) {
    let url = 'Buildings/SetBuildingFloor';
    return this.post(this.api + url, buildingFloor);
  }

  //Get method for Buildings WallMaterials
  getBuildingsWallMaterials(buildingID: number, materialTypeID?: number) {
    let url = "Buildings/GetWallMaterials";
    return this.get(this.api + url, { buildingID: buildingID, materialTypeID: materialTypeID });
  }
  setBuildingsWallMaterials(buildingWallMaterials: BuildingWallMaterials) {
    let url = "Buildings/SetBuildingWallMaterials";
    return this.post(this.api + url, buildingWallMaterials);
  }

  updLivingComplexPhoto(DBFileID: number, LivingComplexID: number) {
    let url = 'LivingComplexes/UpdLivingComplexPhoto';
    return this.get(this.api + url, { DBFileID: DBFileID, LivingComplexID: LivingComplexID });
  }

  getPortalLicense(functionalID: number, roleId: number) {
    let uri = 'PortalLicense/GetLicense';
    return this.get(this.api + uri, { functionalID: functionalID, roleId: roleId });
  }

  getLivingComplexInfo_BuildProcess2(BuildingID: number, StageID: any): Promise<BuildProcess> {
    let url = 'BuildingBuildProcesses/Get';
    return this.get(this.api_widget + url, { BuildingID: BuildingID, StageID: StageID });
  }

  getFinanceObjectData(cityId: number, complexId: number): any {
    let url = 'Widget_A_Analysis/Get_A_1_3';
    return this.get(this.api_widget + url, { cityID: cityId, livingComplexID: complexId });
  }
  insertActFile(
    LivingComplexID: number,
    FileExtension: string,
    file: File,
    FileTypeId: number
  ) {
    let uri = "Files/UploadDocument";
    const formData: FormData = new FormData();
    formData.append("LivingComplexID", LivingComplexID.toString());
    formData.append("documentType", FileTypeId.toString());
    formData.append("FileExtension", FileExtension);
    formData.append("uploadedFile", file, file.name);
    return this.post(this.api + uri, formData);
  }

  deleteSelectedFlat(spotObjectId: number, floorID: number, roomCountID: number, flatID) {
    let uri = "Buildings/DelFlatFromBuildingFloorCountOfRooms";
    return this.get(this.api + uri, {
      buildingID: spotObjectId,
      floorID: floorID,
      roomCountID: roomCountID,
      flatId: flatID
    });
  }

  insertBlock(block: Block): any {
    const body = new HttpParams()
      .set("Id", (block.id != null) ? block.id.toString() : null)
      .set("Title", block.title)
      .set("BlockNumber", block.blockNumber)
      .set("BuildingID", block.buildingID.toString());
    let uri = "LivingComplexes/SetBlock";
    return this.http.post(this.api + uri, body.toString(), {
      headers: this.httpHeaders
    }).toPromise().then(res => res);
  }

  getBlocks(buildingId: number): any {
    let url = 'LivingComplexes/GetBlocks';
    return this.get(this.api + url, { blockId: null, buildingId: buildingId });
  }

  deleteBlock(blockId: number) {
    let url = 'LivingComplexes/DelBlock';
    return this.get(this.api + url, {
      Id: blockId,

    });
  }

  getBuildingFurnishItemTemplate(buildingId: number) {
    let url = 'Buildings/GetBuildingFurnishItemTemplate';
    return this.get(this.api + url, { buildingId: buildingId });
  }

  setBuildingFurnishItemTemplate(buildingId: number, furnishItemsList: any) {
    let url = '';
    if (furnishItemsList.length > 0) {
      url = `Buildings/SetBuildingFurnishItemTemplate?buildingID=${buildingId}&furnishItemsList=${furnishItemsList}`;
    } else {
      url = `Buildings/SetBuildingFurnishItemTemplate?buildingID=${buildingId}`;
    }
    return this.post(this.api + url, {});
  }

  delActFile(fileID) {

    let url = 'BuildingFiles/DelBuildingDocument?fileId=' + fileID;
    return this.delet(this.api + url, {});
  }

  noChanges(livingComplexId, factDate, versionId) {
    let url = `LivingComplexes/NoInvestAmountOnDate?livingComplexId=${livingComplexId}&factDate=${factDate}&versionId=${versionId}`;
    return this.post(this.api + url, {});
  }
  lastDate() {
    let url = "LivingComplexes/LastDateForInvestAmounts";
    return this.get(this.api + url, {});
  }
  setActDate(DBFileID: number, DocumentDate) {
    let url = `BuildingFiles/SetDocumentDate?DBFileID=${DBFileID}&DocumentDate=${DocumentDate}`;
    return this.post(this.api + url, {});
  }
  noChangesReal(buildingId) {
    let url = `Buildings/SetBuildingFlatNoSale?BuildingID=${buildingId}`;
    return this.post(this.api + url, {});
  }
  setPhotoComment(comment: CommentPhoto) {
    let url = "Files/SetComments";
    return this.post(this.api + url, comment);
  }
  getPhotoComments(DBFileID) {
    let url = `Files/GetComments?DBFileID=${DBFileID}`;
    return this.get(this.api + url, {});
  }

  getError(code: number) {
    let url = 'admin/ping';
    return this.get(this.api + url, { code });
  }
  removePlan(fileID) {
    let url = `BuildingFiles/DelBuildingFlatSalesFile?fileId=${fileID}`
    return this.get(this.api + url, {});
  }
  getVideoInstructionName() {
    let url = 'VideoInstruction/GetManuals'
    return this.get(this.api + url, {});
  }
  showVideo(id: number) {
    let url = `VideoInstruction/GetVideo?id=${id}`
    return this.get(this.api + url, {});
  }
  getOwnPartners() {
    let url = 'Info/GetPrivatePartners';
    return this.get(this.api + url, {});
  }
  setLivingComplexDocumentNumber(dbFileId, docNumber: number) {
    let url = `Buildings/SetLivingComplexDocumentNumber?DBFileID=${dbFileId}&DocumentNumber=${docNumber}`;
    return this.get(this.api + url, {});
  }
  getCurators(): Promise<Array<ICurator>> {
    let url = 'LivingComplexes/GetAllCurators';
    return this.get(this.api + url, {});
  }
  setCourator(objectID: number, couratorId: number) {
    let url = `LivingComplexes/SetLivingComplexCurator?LivingComplexID=${objectID}&CuratorID=${couratorId}`;
    return this.post(this.api + url, {});

  }

  getOtherRooms(buildingID): Promise<any> {
    let url = `Buildings/GetBuildingOtherRooms?buildingID=${buildingID}`;
    return this.get(this.api + url, {});

  }

  getTroubleQuestion(BuildingID): Promise<any> {
    let url = `Buildings/GetTrubleQuestion?BuildingID=${BuildingID}`;
    return this.get(this.api + url, {});
  }

  setTroubleQuestion(LivingComplexID: number, trubleQuestion: string) {
    let url = `Buildings/SetTrubleQuestion`;
    let trouble = {
      LivingComplexID: LivingComplexID,
      trubleQuestion: trubleQuestion
    };
    return this.post(this.api + url, trouble);
  }

  downloadReport(regionID?: number, cityAreaID?: number, livingComplexID?: number) {
    let url = `MIOReports/GetAllLivingComplexes?regionID=${regionID}&cityAreaID=${cityAreaID}&livingComplexID=${livingComplexID}`;
    this.http.get(this.api + url, { observe: 'response', responseType: 'blob' }).subscribe(res => {
      let fileName = decodeURIComponent(encodeURI(res.headers.get('FileName')));
      this.saveFile(res.body, fileName);
    });
  }

  saveFile(blobContent: Blob, fileName: string) {
    let blob = new Blob([blobContent], { type: 'application/octet-stream' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  copyFlats(buildingID: number, fromFloorID: number, toFloorID: number[]) {
    let obj = {
      "buildingID": buildingID,
      "fromFloorID": fromFloorID,
      "toFloorID": toFloorID,
    };
    return this.http.post(this.api + 'Buildings/CopyFlats', obj, { observe: 'response' });
  }

  copyBuilding(BuildingID: number) {
    return this.http.post(this.api + `Buildings/CopyBuilding?BuildingID=${BuildingID}`, {}, { observe: 'response' });
  }

  downloadDocument(fileID){
    let url = this.api + `Files/DownloadDocument?fileID=${fileID}`;
    return this.http.get(url,{responseType: 'blob'});
  }

}

export interface IBuildProcess {
  infoPercent: IInfoPercent[];
  infoStage: IInfoStage[];
  infoVersion: IInfoVersion[];
}

export interface IInfoPercent {
  stageID: number;
  completionPercent: number;
  factDate: Date;
  factDateTimestamp: number;
  troubleFactorList: number;
}

export interface IInfoStage {
  deviationTypeID: number;
  stageID: number;
}

export interface IInfoVersion {
  versionID: number;
  stageID: number;
  startDate: Date;
  endDate: Date;
  startDateTimestamp?: number;
  endDateTimestamp?: number;
}

export interface IHistory {
  blockTitle: string;
  columnName: string;
  columnTitle: string;
  historyID: number;
  historyTime: string;
  operType: string;
  rowOrder: number;
  updatedOn: string;
  userID: number;
  userMIOTitle: string;
  userName: string;
  value: string;
  valueNum: number;
  isFile?: boolean;
  dbFileID?: number;
  fileExtension?: string;
}
